<template>
  <div>
    <div class="tableTitle">
      <div class="titleLeft">
        <span>打印队列（当前共{{ tableData.length }}条）</span>
        <img
          v-show="isLoadingPrintList"
          src="@/assets/img/printingPage/loading.gif"
          alt="加载"
        />
      </div>
      <div class="titleRight">
        <div
          v-if="multipleSelection.length"
          class="batchDeleteBox"
          @click="batchCancelConfirm"
        >
          <i class="batchDelete"></i>
          <p>批量删除</p>
        </div>
        <i class="deleteLine" v-if="multipleSelection.length"></i>
        <i class="refresh" @click="getPrintingListFn"></i>
        <div class="searchBox">
          <i class="icon"></i>
        </div>
      </div>
    </div>
    <el-table
      :data="
        tableData.slice((currentPage - 1) * PageSize, currentPage * PageSize)
      "
      row-key="id"
      height="450"
      v-loading="$store.state.request.requestCount"
      @select="handleSelectionChange"
      @select-all="handleSelectionAllChange"
      ref="table"
      style="width:100%"
      :default-sort="{ prop: 'date', order: 'descending' }"
    >
      <template slot="empty">
        <div class="emptyTemplate">
          <div>
            <img src="@/assets/img/printingPage/empty.png" alt="" />
            <span>暂无数据</span>
          </div>
        </div>
      </template>
      <el-table-column
        type="selection"
        :selectable="selectable"
        reserve-selection
        width="35"
      >
      </el-table-column>
      <el-table-column
        class="fileName"
        prop="fileName"
        label="文件名"
        min-width="28%"
      >
        <template slot-scope="scope">
          <el-popover
            placement="right"
            trigger="hover"
            :content="scope.row.fileName"
          >
            <p slot="reference" class="fileNameOver">
              {{ scope.row.fileName }}
            </p>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="equipmentAlias" label="打印机" min-width="20%">
        <template slot-scope="scope">
          <p v-if="scope.row.status === '5'">扫码打印</p>
          <p v-else>{{ scope.row.equipmentAlias || "--" }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="printingCopies" min-width="11%" label="打印份数">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="创建时间"
        sortable
        min-width="11%"
      >
      </el-table-column>
      <el-table-column prop="status" label="状态" min-width="14%">
        <template slot-scope="scope">
          <div class="statusRow">
            <i :class="scope.row.status | stateTransitionClass"></i
            ><span
              :title="
                scope.row.status === '3' ? scope.row.statusDesc || '' : ''
              "
              >{{ scope.row.status | stateTransition }}</span
            >
            <span v-if="scope.row.show">({{ scope.row.show }})</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="6%">
        <template slot-scope="scope">
          <div class="operationContent" :title="scope.status">
            <el-dropdown trigger="click">
              <div class="moreBox">
                <i class="moreOperations"></i>
              </div>
              <el-dropdown-menu class="operation" slot="dropdown">
                <el-dropdown-item
                  @click.native="topSortFn(scope.row)"
                  v-if="Number(scope.row.status) !== 3"
                  :disabled="
                    Number(scope.row.status) === 1 ||
                      Number(scope.row.status) === 5
                  "
                >
                  <i
                    :class="
                      Number(scope.row.status) === 1 ||
                      Number(scope.row.status) === 5
                        ? 'disabled'
                        : 'first'
                    "
                  ></i>
                  <span>优先打印</span>
                </el-dropdown-item>
                <el-dropdown-item v-else @click.native="reprintFn(scope.row)">
                  <i class="againIcon"></i>
                  <span>重新打印</span>
                </el-dropdown-item>
                <el-dropdown-item @click.native="cancel(scope.row)">
                  <i class="cancel"></i>
                  <span>取消打印</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="paging"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[20, 50, 100]"
      :current-page="currentPage"
      :page-size="PageSize"
      layout="prev, pager, next,sizes"
      :total="tableData.length"
    >
    </el-pagination>
  </div>
</template>

<script>
import { generalPopupInstance } from "common/components/web/generalPopup/generalPopup";
import { cancelPrinting, topSort, batchCancelPrinting, reprint } from "api/api";

export default {
  data() {
    return {
      PageSize: 20, //每页展示条数
      currentPage: 1, //当前页
      multipleSelection: [], //多选中文件
    };
  },
  props: {
    isLoadingPrintList: {
      type: Boolean,
    },
    tableData: {
      type: Array,
    },
  },
  methods: {
    //单选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //全选
    handleSelectionAllChange() {
      // 是否全选;
      if (this.multipleSelection.length !== this.tableData.filter(item => !item.orderNo).length) {
        this.selectionAllChange = true;
        this.multipleSelection = this.tableData.filter(item => !item.orderNo);
      } else {
        this.selectionAllChange = false;
        this.$refs.table.clearSelection();
        this.multipleSelection = [];
      }
      //勾选
      for (let item of this.multipleSelection) {
        this.$refs.table.toggleRowSelection(item, this.selectionAllChange);
      }
    },
    // 每页显示的条数
    handleSizeChange(val) {
      // 改变每页显示的条数
      this.PageSize = val;
      // 注意：在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage = 1;
    },
    // 显示第几页
    handleCurrentChange(val) {
      // 改变默认的页数
      this.currentPage = val;
    },
    getPrintingListFn() {
      this.$emit("refresh");
    },
    // 过滤不可选中项
    selectable(value) {
      return !value.orderNo;
    },
    //优先打印
    topSortFn(data) {
      let params = {
        printNo: data.printNo,
      };
      topSort(params)
        .then((res) => {
          const { code } = res;
          if (code === 0) {
            this.$message({
              message: "置顶成功",
              duration: 2000,
              customClass: "messageTip",
              type: "success",
            });
            //刷新列表
            this.getPrintingListFn();
          }
        })
        .catch();
    },
    //批量取消
    batchCancelConfirm() {
      const generalPopup = generalPopupInstance({
        icon: "warningIcon",
        title: "取消打印",
        message: `确定要取消打印【选中的所有文件】吗？`,
        beforeClose: (action, done) => {
          if (action === "confirm") {
            this.batchCancelPrintingFn();
            done();
            generalPopup.destory();
          } else {
            done();
            generalPopup.destory();
          }
        },
      });
    },
    //批量取消
    batchCancelPrintingFn() {
      this.$emit("clearInterval"); //取消轮询
      this.loading = true;
      let printNoList = [];
      for (let item of this.multipleSelection) {
        printNoList.push(item.printNo);
      }
      batchCancelPrinting(printNoList)
        .then((res) => {
          const { code } = res;
          if (code === 0) {
            this.$message({
              message: "取消打印成功",
              duration: 1500,
              customClass: "messageTip",
              type: "success",
            });
            this.loading = false;
            this.$refs.table.clearSelection();
            this.getPrintingListFn(); //更新打印列表
          }
        })
        .catch(() => {
          this.$message({
            message: "取消打印失败",
            duration: 1500,
            customClass: "messageTip",
            type: "success",
          });
          this.loading = false;
          this.$refs.table.clearSelection();
        });
    },
    //取消
    cancel(item) {
      if (item.orderNo)
        return this.$alert({
          title: "提示",
          subTitle: "付费打印无法取消",
          description: "",
        });
      const generalPopup = generalPopupInstance({
        icon: "warningIcon",
        title: "取消打印",
        message: `确定要取消打印【${item.fileName}】吗？`,
        beforeClose: (action, done) => {
          if (action === "confirm") {
            this.cancelPrintingFn(item.printNo);
            done();
            generalPopup.destory();
          } else {
            done();
            generalPopup.destory();
          }
        },
      });
    },
    //取消打印
    cancelPrintingFn(printNo) {
      cancelPrinting({ printNo: printNo })
        .then((res) => {
          const { code } = res;
          if (code === 0) {
            //设备列表更新
            this.getPrintingListFn(); //打印列表
            this.currentPage = 1;
          }
        })
        .catch();
    },
    //重新打印
    reprintFn({ printNo, orderNo, userId, printUserId, traceless }) {

      const currentUserId = this.getCurrentUser().userId;
      if (orderNo && currentUserId.toString() !== userId.toString()) {
        this.$message({
          message: "请联系商家处理",
          duration: 2000,
          customClass: "messageTip",
          type: "error",
        });
      } else if (traceless === "yes") {
        this.$alert({
          title: "提示",
          subTitle: "无痕打印，不支持重新打印",
          description: "",
        });
      } else {
        this.dispatchReprint(printNo);
      }
    },
    // 发起重新打印
    dispatchReprint(printNo) {
      reprint({ printNo }).then((res) => {
        const { code } = res;
        if (code === 0) {
          //刷新列表
          this.getPrintingListFn();
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../index.scss";

.tableTitle {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .titleLeft,
  .titleRight {
    display: flex;
    align-items: center;
    .batchDeleteBox {
      display: flex;
      align-items: center;
      cursor: pointer;
      &:hover {
        .batchDelete {
          background: url("~@/assets/img/printingPage/batch_delete_h.png")
            no-repeat center;
        }
      }
      p {
        color: $theme-color;
        font-size: 14px;
      }
    }
    .deleteLine {
      display: block;
      width: 1px;
      height: 14px;
      border-right: 1px solid #eeeeee;
      margin: 0 20px;
    }
    .batchDelete {
      display: block;
      background: url("~@/assets/img/printingPage/batch_delete.png") no-repeat
        center;
      width: 12px;
      height: 12px;
      margin-right: 8px;
    }
  }
  .refresh {
    display: block;
    background: url("~@/assets/img/printingPage/refresh.png") no-repeat center;
    width: 20px;
    height: 20px;
    cursor: pointer;
    &:hover {
      background: url("~@/assets/img/printingPage/refresh_h.png") no-repeat
        center;
    }
  }
  .line {
    width: 1px;
    height: 32px;
    background-color: #eeeeee;
    margin: 0 20px;
  }
  .searchBox {
    border: 1px solid #eeeeee;
    display: flex;
    align-items: center;
    &:hover {
      border-color: $theme-color;
    }
  }
}

.emptyTemplate {
  min-height: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    display: flex;
    flex-direction: column;
    color: #424242;
    font-size: 16px;
    span {
      margin: 18px 0 0 0;
    }
  }
}

.fileNameOver {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
  display: inline-block;
  &:hover {
    cursor: pointer;
  }
}
.operation {
  width: 99px;
  height: 90px;
  box-sizing: border-box;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  li.el-dropdown-menu__item {
    display: flex;
    align-items: center;
    padding: 0;
    height: 32px;
    font-size: 14px;
    padding: 0 0 0 12px;
    &:hover {
      background-color: #f8f8f8;
      .first {
        background: url("~@/assets/img/printingPage/first_h.png") no-repeat
          center;
      }
      .againIcon {
        background: url("~@/assets/img/printingPage/again_h.png") no-repeat
          center;
      }
      .cancel {
        background: url("~@/assets/img/printingPage/cancel_h.png") no-repeat
          center;
      }
    }
    .disabled {
      display: block;
      background: url("~@/assets/img/printingPage/first_d.png") no-repeat center;
      width: 14px;
      height: 15px;
      margin: 0 6px 0 0;
    }
    .first {
      display: block;
      background: url("~@/assets/img/printingPage/first.png") no-repeat center;
      width: 14px;
      height: 15px;
      margin: 0 6px 0 0;
    }
    .againIcon {
      display: block;
      background: url("~@/assets/img/printingPage/again.png") no-repeat center;
      background-size: 100%;
      width: 13px;
      height: 13px;
      margin: 0 6px 0 0;
    }
    .cancel {
      display: block;
      background: url("~@/assets/img/printingPage/cancel.png") no-repeat center;
      width: 14px;
      height: 15px;
      margin: 0 6px 0 0;
    }
  }
}
</style>
